import { render, staticRenderFns } from "./cambio-password.vue?vue&type=template&id=ccab261a"
import script from "./cambio-password.vue?vue&type=script&lang=js"
export * from "./cambio-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports